import React, { memo } from "react";
import { i18n } from "../../../translate/i18n";
import { CopyIcon, OpenAIIcon, TrashIcon } from "../icons/FlowIcons";
import { useNodeStorage } from "../../../stores/useNodeStorage";
import { TargetHandle, glassStyle, FlowOutputHandle, TimeoutOutputHandle } from "./NodeHandles";

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();
  return (
    <div style={glassStyle} className="flow-node-card">
      <TargetHandle isConnectable={isConnectable} />
      <div
        className="node-actions"
        style={{
          display: "flex",
          position: "absolute",
          right: 5,
          top: 5,
          cursor: "pointer",
          gap: 6,
        }}
      >
        <CopyIcon
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("duplicate");
          }}
          style={{ width: "12px", height: "12px", color: "var(--flow-text-muted)" }}
        />

        <TrashIcon
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("delete");
          }}
          style={{ width: "12px", height: "12px", color: "var(--flow-text-muted)" }}
        />
      </div>
      <div
        style={{
          color: "var(--flow-text)",
          fontSize: "16px",
          flexDirection: "row",
          display: "flex",
        }}
      >
       <OpenAIIcon
          style={{
            width: "16px",
            height: "16px",
            marginRight: "4px",
            marginTop: "4px",
            color: "var(--flow-icon-color)"
          }}
        />
        <div style={{ color: "var(--flow-text)", fontSize: "16px" }}>{i18n.t("flowBuilderConfig.nodes.openai")}</div>
      </div>
      <div style={{ color: "var(--flow-text)", fontSize: "12px", width: 180 }}>
        <div
          style={{
            backgroundColor: "var(--flow-node-inner-bg)",
            marginBottom: "3px",
            borderRadius: "5px",
          }}
        >
          <div style={{ gap: "5px", padding: "6px" }}>
            <div style={{ textAlign: "center" }}>{i18n.t("flowBuilderConfig.nodes.openai")}</div>
          </div>
        </div>
      </div>
      <FlowOutputHandle isConnectable={isConnectable} />
      <TimeoutOutputHandle
        isConnectable={isConnectable}
        label={data.timeoutSeconds > 0 ? `Timeout ${data.timeoutSeconds}s` : i18n.t("flowBuilderConfig.nodes.noResponse")}
      />
    </div>
  );
});

